import { Link } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import FeedbackForm from "@/pages/about/components/FeedbackForm";

const services = [
  {
    icon: "ri-film-line",
    title: "影视剧内容索引",
    desc: "系统整理“出轨的味道”系列及相关影视剧的剧名、封面、类型、集数与更新状态，方便快速查找。",
  },
  {
    icon: "ri-book-open-line",
    title: "详细剧情介绍",
    desc: "提供剧情梗概、剧情看点与结构化的剧集信息，帮助观众在追剧前了解故事走向与人物关系。",
  },
  {
    icon: "ri-user-star-line",
    title: "演员资料与名单",
    desc: "收录主要演员的头像、姓名与饰演角色，让观众可以快速对应人物与演员信息。",
  },
  {
    icon: "ri-newspaper-line",
    title: "相关资讯与评论",
    desc: "汇总该主题影视剧的最新动态、幕后花絮与深度评论，持续更新内容专题。",
  },
];

const contacts = [
  { icon: "ri-mail-line", label: "联系邮箱", value: "hello@chuguiweidao.site" },
  { icon: "ri-wechat-line", label: "微信公众号", value: "出轨的味道" },
  { icon: "ri-time-line", label: "内容更新", value: "每周三、周六" },
];

export default function About() {
  useDocumentMeta({
    title: "关于我们 - 出轨的味道影视内容站",
    description: "出轨的味道影视内容站介绍、联系方式与反馈入口。了解站点定位、服务内容、版权声明与法律信息。",
    keywords: "出轨的味道,关于我们,影视内容站,联系方式,版权声明,网站介绍",
  });

  return (
    <AppLayout>
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-8 md:py-10">
        <nav aria-label="面包屑" className="flex items-center gap-2 text-xs text-foreground-500">
          <Link to="/" className="transition-colors hover:text-accent-700 cursor-pointer">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-800">关于我们</span>
        </nav>

        <header className="mt-5">
          <p className="font-label text-[11px] tracking-[0.3em] text-accent-600">ABOUT US</p>
          <h1 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于“出轨的味道”影视内容站
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-foreground-600">
            我们是一个专注于“出轨的味道”主题影视内容的展示与资讯平台。站点围绕该系列影视剧，提供全集信息索引、详细剧情介绍、
            演员资料与相关资讯，帮助影视剧爱好者在同一个地方完成查找与深入了解。
          </p>
        </header>

        <section className="mt-10">
          <h2 className="font-heading text-xl font-bold text-foreground-950">网站定位与服务内容</h2>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {services.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-medium text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.1fr]">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950">联系方式</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如果你对站内内容有任何疑问、建议或合作意向，欢迎通过以下方式与我们取得联系。
            </p>
            <ul className="mt-5 flex flex-col gap-3">
              {contacts.map((item) => (
                <li
                  key={item.label}
                  className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <span className="flex flex-col">
                    <span className="text-xs text-foreground-500">{item.label}</span>
                    <span className="text-sm font-medium text-foreground-900">{item.value}</span>
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-6 rounded-lg bg-primary-950 p-5 text-background-50">
              <p className="flex items-center gap-2 font-medium">
                <i className="ri-information-line text-accent-400"></i>
                温馨提示
              </p>
              <p className="mt-2 text-xs leading-relaxed text-background-50/70">
                本站所有剧集目录、演员信息与资讯内容均为影视内容展示与演示用途，不提供任何影视资源的播放、下载或售卖服务。
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h2 className="font-heading text-xl font-bold text-foreground-950">意见反馈</h2>
            <p className="mt-2 mb-5 text-sm leading-relaxed text-foreground-600">
              你的每一条建议都会被认真阅读，帮助我们持续完善站内内容与体验。
            </p>
            <FeedbackForm />
          </div>
        </section>

        <section className="mt-12 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
          <h2 className="font-heading text-xl font-bold text-foreground-950">版权声明与法律信息</h2>
          <div className="mt-4 flex flex-col gap-4 text-sm leading-7 text-foreground-600">
            <div>
              <h3 className="font-medium text-foreground-900">一、版权归属</h3>
              <p className="mt-1">
                本网站为影视内容展示与资讯平台，站内文字、排版与整理内容由本站编辑制作。站内涉及的部分影视剧名称、海报与相关资料，
                其版权归原影视作品权利人所有，本站仅用于内容介绍、评论与资讯展示之目的。
              </p>
            </div>
            <div>
              <h3 className="font-medium text-foreground-900">二、内容使用</h3>
              <p className="mt-1">
                未经授权，任何组织或个人不得将本站内容用于商业用途或以任何形式进行批量转载。如需引用，请注明来源并保留原文链接。
              </p>
            </div>
            <div>
              <h3 className="font-medium text-foreground-900">三、免责声明</h3>
              <p className="mt-1">
                本站不存储、不提供任何影视资源，亦不参与任何影视作品的播放与下载。用户在站内看到的所有剧集信息仅作为内容索引与剧情介绍参考。
                若内容存在信息偏差，欢迎通过上方反馈入口与我们联系，我们会及时核实并更正。
              </p>
            </div>
            <div>
              <h3 className="font-medium text-foreground-900">四、权利通知</h3>
              <p className="mt-1">
                若相关权利人认为站内内容侵犯其合法权益，请通过联系邮箱提供相关证明，我们将在核实后第一时间处理。
              </p>
            </div>
          </div>
        </section>
      </div>
    </AppLayout>
  );
}